import type { StandardProposalsView } from "@buildpy/core/views/g5a/standard-proposals";

import ProposalsBoard from "@/modules/process-standard/ui/proposals-board";
import StandardsShell from "@/modules/process-standard/ui/standards-shell";
import type { ProposalPhase } from "@/modules/process-standard/ui/standards-search";

// 숫자 제안 목록(#386).
const Page = ({ data, phase }: { data: StandardProposalsView; phase: ProposalPhase | null }) => (
  <StandardsShell tab="proposals">
    <ProposalsBoard data={data} phase={phase} />
  </StandardsShell>
);

export default Page;
